import React from "react";
import get from "lodash.get";
import { connect } from "react-redux";

import ParkkiTheme from "themes/ParkkiTheme";
import PDFViewer from "components/PDFViewer";
import ReportsUtils from "services/reports/utils";

const styles = {
  container: {
    display: "flex",
    flex: 1,
    height: "100%",
    backgroundColor: ParkkiTheme.colors.lightGrey,
    flexDirection: "column",
  },
};

class PDFViewerLayout extends React.Component {
  render() {
    const { selectedPdf } = this.props;
    return (
      <div style={styles.container}>
        <PDFViewer url={get(selectedPdf, "url", null)} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedPdf: ReportsUtils.getSelectedReport(state.Reports),
});

const mapDispatchToProps = (dispatch) => ({});

PDFViewerLayout.defaultProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PDFViewerLayout);
